import { trackConfig, type IFramework } from '@/framework';
import { LayerType, type ILayerProps, type ITextLayerProps, type TextAlignType } from '@/version-types';
import { pushHistory, updateLayer, validateInputLayer } from '../utils';

export interface IAlignment {
    /**
     * 设置水平对齐方式
     * @param layerID - 图层 id
     * @param align - 对齐方式
     * @returns
     */
    setTextAlign(layerID: string, align: TextAlignType): void;
}

const FUNC_ID = trackConfig[LayerType.TEXT_LAYER].textAlign;

export class Alignment implements IAlignment {
    constructor(private framework: IFramework) {}

    private prepare(prevLayer: ILayerProps, value: TextAlignType) {
        const prevLayerData = prevLayer.data as ITextLayerProps;
        const nextLayerData: ITextLayerProps = { ...prevLayerData, textAlign: value };

        return { ...prevLayer, data: nextLayerData };
    }

    private setGroup(prevLayer: ILayerProps, value: TextAlignType) {
        const children = prevLayer.children;
        if (children.length === 0) return;

        const prevAligns = children.map((child) => (child.data as ITextLayerProps).textAlign);
        if (prevAligns.every((item) => item === value)) return;

        const layers = children.map((child) => this.prepare(child, value) || child);
        const nextLayer = { ...prevLayer, children: layers };

        updateLayer(this.framework, nextLayer);
        pushHistory(this.framework, prevLayer, nextLayer, FUNC_ID);

        return nextLayer;
    }

    private setSingle(prevLayer: ILayerProps, value: TextAlignType) {
        const { textAlign: prevTextAlign, shapeExtension } = prevLayer.data as ITextLayerProps;
        if (prevTextAlign === value || shapeExtension) return; // 变形文字不支持设置对齐方式

        const nextLayer = this.prepare(prevLayer, value);
        if (!nextLayer) return;

        updateLayer(this.framework, nextLayer);
        pushHistory(this.framework, prevLayer, nextLayer, FUNC_ID);

        return nextLayer;
    }

    setTextAlign(layerID: string, value: TextAlignType) {
        const prevLayer = this.framework.service.flatLayer.getLayer(layerID, true);
        if (!validateInputLayer(prevLayer)) return;

        if (prevLayer.layerType === LayerType.GROUP_LAYER) {
            return this.setGroup(prevLayer, value);
        }

        return this.setSingle(prevLayer, value);
    }
}
